import React, { createElement, useContext, useEffect, useState } from "react";
import ViewerContext from "../../context/ViewerContext";
import { Height, Settings, SettingsSuggest } from "@mui/icons-material";
import "./configuration.scss";
import ConstellationConfiguration from "./ConstellationConfiguration";
import GlobalConfiguration from "./GlobalConfiguration";
import {
  AppBar,
  Avatar,
  Button,
  Icon,
  IconButton,
  SvgIcon,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";

export default function ConfigTool() {
  const { constellationName, setConstellationName } = useContext(ViewerContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [openGlobalConfigDialog, setOpenGlobalConfigDialog] = useState(false);

  const onOpenFunc = () => {
    setOpenDialog(true);
  };

  const onOpenGlobalFunc = () => {
    setOpenGlobalConfigDialog(true);
  };

  const onOpenStationFunc = () => {
    setStationConfigDialog(true);
  };

  return (
    <>
      <div className="overlay-configuration">
        {/* <Button color="inherit" onClick={onOpenGlobalFunc}>
            Global Settings
          </Button> */}
        <Tooltip title="Global Configuration" arrow>
          <IconButton onClick={onOpenGlobalFunc}>
            <Avatar
              sx={{ width: "32px", height: "32px" }}
              src="./icons/global-settings.png"
            />
          </IconButton>
          {/* <SettingsSuggest onClick={onOpenGlobalFunc} /> */}
        </Tooltip>

        <div onClick={onOpenFunc}>
          <IconButton>
            <Tooltip title="Constellation Configuration" arrow>
              <Avatar
                sx={{ width: "40px", height: "40px", marginTop: "10px" }}
                src="./icons/satellite.png"
              />
            </Tooltip>
            <span style={{ color: "#ffff" }}>{constellationName.name}</span>{" "}
          </IconButton>
        </div>
      </div>
      {openDialog && (
        <ConstellationConfiguration
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
      )}
      {openGlobalConfigDialog && (
        <GlobalConfiguration
          openDialog={openGlobalConfigDialog}
          setOpenDialog={setOpenGlobalConfigDialog}
        />
      )}
    </>
  );
}
